import EventEmitter from 'eventemitter3';

const contextMap = new WeakMap<object, Array<() => void>>();
type targetEventType<T, EventTypes extends EventEmitter.ValidEventTypes> = T extends EventTarget ? string : EventEmitter.EventNames<EventTypes>;
export function create<EventTypes extends EventEmitter.ValidEventTypes = string | symbol, Context = unknown, T extends EventEmitter<EventTypes, Context> | EventTarget = EventTarget>(key: object, target: T) {
  if (!contextMap.has(key)) {
    contextMap.set(key, []);
  }
  const removelist = contextMap.get(key)!;
  const add = (event: targetEventType<T, EventTypes>, fn: EventEmitter.EventListener<EventTypes, EventEmitter.EventNames<EventTypes>>) => {
    if ('addEventListener' in target) {
      removelist.push(target.removeEventListener.bind(target, event, fn));
      target.addEventListener(event, fn);
    } else {
      removelist.push(target.off.bind(target, event, fn));
      target.on(event, fn);
    }
    return result;
  };
  const result = { add };
  return result;
}
export function remove(key: object) {
  const removelist = contextMap.get(key);
  if (removelist) {
    removelist.forEach(fn => fn());
    contextMap.delete(key);
  }
}
